module.exports = __webpack_public_path__ + "assets/retina_RTrByHypAndTangentPtDetailed.ca2fa50cda7d3e40f5c7deb2c30476ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_RTrByHypAndTangentPtDetailed.png
// module id = 708
// module chunks = 0